var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfrastructure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "61px",
    height: "54px",
    viewBox: "0 0 61 54",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-rbulmv-ei0-1",
    points: "0 54 61 54 61 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Topics-Menu---rev9",
    transform: "translate(-279.000000, -281.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-51",
    transform: "translate(279.000000, 281.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.0159039,6 C1.7666309,6 1.51735789,5.90872903 1.32083208,5.72448109 C0.911615981,5.33892522 0.891197715,4.69491044 1.27489098,4.28461757 C3.82206974,1.56098948 7.41823695,0 11.139466,0 C14.7517977,0 18.1480361,1.41000853 20.7020209,3.97071368 C21.0993264,4.36906454 21.0993264,5.01393233 20.7020209,5.4114302 C20.3055662,5.80978106 19.6623908,5.80978106 19.2650854,5.4114302 C17.0947938,3.23542792 14.2090121,2.03696332 11.139466,2.03696332 C7.93039514,2.03696332 4.95358201,3.33011089 2.75691683,5.67841911 C2.55698797,5.89166904 2.28644594,6 2.0159039,6",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00846209,11 C6.78460276,11 6.55989868,10.9287016 6.3723637,10.7828641 C5.93985058,10.4458173 5.87480466,9.83654041 6.22622157,9.42171359 C7.53136369,7.8823172 9.46500143,7 11.5312653,7 C13.5527572,7 15.4593629,7.85152927 16.7628155,9.33502127 C17.1218352,9.74417663 17.0669263,10.3542637 16.6411712,10.6986024 C16.2145714,11.0429411 15.578473,10.9902775 15.2194533,10.5819323 C14.3003629,9.53595301 12.9563622,8.93558841 11.5312653,8.93558841 C10.0749125,8.93558841 8.71232724,9.55782864 7.79154736,10.642698 C7.59218585,10.8776585 7.3015911,11 7.00846209,11",
    id: "Fill-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#FFFFFF",
    points: "1.59306604 52 0 51.503566 10.2205743 18 12.8701589 18 23 51.5053295 21.4051891 51.9982365 11.6356636 19.6850541 11.4515799 19.6850541"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,17.5 C14,18.8802169 12.8808546,20 11.4995892,20 C10.1191454,20 9,18.8802169 9,17.5 C9,16.1197831 10.1191454,15 11.4995892,15 C12.8808546,15 14,16.1197831 14,17.5",
    id: "Fill-7",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83548275,51 C1.52002451,51 1.21767396,50.8186416 1.07698482,50.5105084 C0.883864962,50.0888062 1.06649868,49.58875 1.48594453,49.3950663 L17.4074101,42.004272 L5.39028638,34.4823009 C5.16133885,34.3396792 5.01540664,34.0940531 4.99705589,33.8228959 C4.97957898,33.5526191 5.09317889,33.2893853 5.30115413,33.1177111 L13.6839543,26.1908772 C14.0404833,25.8959498 14.5665383,25.9487726 14.8592766,26.3079678 C15.1520148,26.6671631 15.0995841,27.1971522 14.7430551,27.4911992 L7.26206351,33.6732312 L19.6060055,41.4003309 C19.8664115,41.5640817 20.0175868,41.8581288 19.9983622,42.1671423 C19.9791376,42.4761559 19.7938823,42.7490739 19.5142517,42.8793702 L2.18414711,50.9225265 C2.07142104,50.9753493 1.95257805,51 1.83548275,51",
    id: "Fill-9",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1789602,52 C22.0604883,52 21.9402993,51.9735093 21.8261198,51.9178788 L3.46640111,42.8933784 C3.195976,42.7609249 3.01740958,42.4863046 3.00109822,42.1781294 C2.98564536,41.8690712 3.13416454,41.5767904 3.38999528,41.414314 L15.5986159,33.6657827 L8.22931701,27.4978634 C7.87733512,27.2038165 7.82410859,26.6722364 8.11084505,26.3110798 C8.39586453,25.9499231 8.91267697,25.8951757 9.26465886,26.1892225 L17.5293653,33.1059457 C17.7354035,33.2790183 17.847866,33.5430424 17.8298376,33.8158966 C17.8126678,34.0878679 17.6684411,34.3351145 17.4426576,34.4781643 L5.53107536,42.0386117 L22.5335176,50.3946632 C22.94216,50.5959926 23.1147169,51.099316 22.9198392,51.5196352 C22.7790464,51.8225123 22.485442,52 22.1789602,52",
    id: "Fill-11",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-rbulmv-ei0-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-rbulmv-ei0-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#FFFFFF",
    mask: "url(#mask-rbulmv-ei0-2)",
    points: "10.3585 17 10.6415 17 10.6415 10 10.3585 10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    fill: "#FFFFFF",
    mask: "url(#mask-rbulmv-ei0-2)",
    points: "-1 53 23 53 23 50 -1 50"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#FFFFFF",
    mask: "url(#mask-rbulmv-ei0-2)",
    points: "8 52 14 52 14 48 8 48"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    fill: "#FFFFFF",
    mask: "url(#mask-rbulmv-ei0-2)",
    points: "17 31 18 31 18 23 17 23"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fill: "#FFFFFF",
    mask: "url(#mask-rbulmv-ei0-2)",
    points: "15 25.9715 18 25.9715 18 25.0285 15 25.0285"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    fill: "#FFFFFF",
    mask: "url(#mask-rbulmv-ei0-2)",
    points: "15 28.9715 18 28.9715 18 28.0285 15 28.0285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,21.5 C11,22.3285078 10.3286947,23 9.50041748,23 C8.67214027,23 8,22.3285078 8,21.5 C8,20.6714922 8.67214027,20 9.50041748,20 C10.3286947,20 11,20.6714922 11,21.5",
    id: "Fill-20",
    fill: "#FFFFFF",
    mask: "url(#mask-rbulmv-ei0-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,25 C10,26.1048593 9.10485934,27 8,27 C6.89514066,27 6,26.1048593 6,25 C6,23.8951407 6.89514066,23 8,23 C9.10485934,23 10,23.8951407 10,25",
    id: "Fill-21",
    fill: "#FFFFFF",
    mask: "url(#mask-rbulmv-ei0-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#FFFFFF",
    mask: "url(#mask-rbulmv-ei0-2)",
    points: "4 31 5 31 5 23 4 23"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    fill: "#FFFFFF",
    mask: "url(#mask-rbulmv-ei0-2)",
    points: "5 25.9715 8 25.9715 8 25.0285 5 25.0285"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-24",
    fill: "#FFFFFF",
    mask: "url(#mask-rbulmv-ei0-2)",
    points: "5 28.9715 8 28.9715 8 28.0285 5 28.0285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2104607,54 L32.7895393,54 C31.8009909,54 31,53.1893905 31,52.1889713 L31,1.8110287 C31,0.811480168 31.8009909,0 32.7895393,0 L58.2104607,0 C59.1990091,0 60,0.811480168 60,1.8110287 L60,52.1889713 C60,53.1893905 59.1981488,54 58.2104607,54",
    id: "Fill-25",
    fill: "#000000",
    mask: "url(#mask-rbulmv-ei0-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3043101,53 L33.6956899,53 C32.7584611,53 32,52.2330125 32,51.2872073 L32,2.71279268 C32,1.76698751 32.7584611,1 33.6956899,1 L57.3043101,1 C58.2406711,1 59,1.76698751 59,2.71279268 L59,51.2872073 C59,52.2330125 58.2406711,53 57.3043101,53 Z",
    id: "Stroke-26",
    stroke: "#434345",
    strokeWidth: 0.154,
    mask: "url(#mask-rbulmv-ei0-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,3.5 C46,3.77624309 45.7762431,4 45.5,4 C45.2237569,4 45,3.77624309 45,3.5 C45,3.22375691 45.2237569,3 45.5,3 C45.7762431,3 46,3.22375691 46,3.5",
    id: "Fill-27",
    fill: "#3F3F40",
    mask: "url(#mask-rbulmv-ei0-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8205,3.5 C44.8205,3.677 44.6775,3.82 44.5005,3.82 C44.3235,3.82 44.1795,3.677 44.1795,3.5 C44.1795,3.323 44.3235,3.18 44.5005,3.18 C44.6775,3.18 44.8205,3.323 44.8205,3.5",
    id: "Fill-28",
    fill: "#3F3F40",
    mask: "url(#mask-rbulmv-ei0-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2069597,13 L34.7930403,13 C34.3553114,13 34,12.6446886 34,12.2069597 L34,8.79304029 C34,8.35531136 34.3553114,8 34.7930403,8 L38.2069597,8 C38.6446886,8 39,8.35531136 39,8.79304029 L39,12.2069597 C39,12.6446886 38.6446886,13 38.2069597,13",
    id: "Fill-29",
    fill: "#FBB648",
    mask: "url(#mask-rbulmv-ei0-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2069597,13 L40.7930403,13 C40.3553114,13 40,12.6446886 40,12.2069597 L40,8.79304029 C40,8.35531136 40.3553114,8 40.7930403,8 L44.2069597,8 C44.6446886,8 45,8.35531136 45,8.79304029 L45,12.2069597 C45,12.6446886 44.6446886,13 44.2069597,13",
    id: "Fill-30",
    fill: "#F3783E",
    mask: "url(#mask-rbulmv-ei0-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2069597,13 L47.7930403,13 C47.3553114,13 47,12.6446886 47,12.2069597 L47,8.79304029 C47,8.35531136 47.3553114,8 47.7930403,8 L51.2069597,8 C51.6446886,8 52,8.35531136 52,8.79304029 L52,12.2069597 C52,12.6446886 51.6446886,13 51.2069597,13",
    id: "Fill-31",
    fill: "#F59184",
    mask: "url(#mask-rbulmv-ei0-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2069597,13 L53.7930403,13 C53.3553114,13 53,12.6446886 53,12.2069597 L53,8.79304029 C53,8.35531136 53.3553114,8 53.7930403,8 L57.2069597,8 C57.6446886,8 58,8.35531136 58,8.79304029 L58,12.2069597 C58,12.6446886 57.6446886,13 57.2069597,13",
    id: "Fill-32",
    fill: "#EE403A",
    mask: "url(#mask-rbulmv-ei0-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2069597,19 L34.7930403,19 C34.3553114,19 34,18.6446886 34,18.2069597 L34,14.7930403 C34,14.3553114 34.3553114,14 34.7930403,14 L38.2069597,14 C38.6446886,14 39,14.3553114 39,14.7930403 L39,18.2069597 C39,18.6446886 38.6446886,19 38.2069597,19",
    id: "Fill-33",
    fill: "#5F7455",
    mask: "url(#mask-rbulmv-ei0-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2069597,19 L40.7930403,19 C40.3553114,19 40,18.6446886 40,18.2069597 L40,14.7930403 C40,14.3553114 40.3553114,14 40.7930403,14 L44.2069597,14 C44.6446886,14 45,14.3553114 45,14.7930403 L45,18.2069597 C45,18.6446886 44.6446886,19 44.2069597,19",
    id: "Fill-34",
    fill: "#A2AF58",
    mask: "url(#mask-rbulmv-ei0-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2069597,19 L47.7930403,19 C47.3553114,19 47,18.6446886 47,18.2069597 L47,14.7930403 C47,14.3553114 47.3553114,14 47.7930403,14 L51.2069597,14 C51.6446886,14 52,14.3553114 52,14.7930403 L52,18.2069597 C52,18.6446886 51.6446886,19 51.2069597,19",
    id: "Fill-35",
    fill: "#9080A8",
    mask: "url(#mask-rbulmv-ei0-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2069597,19 L53.7930403,19 C53.3553114,19 53,18.6446886 53,18.2069597 L53,14.7930403 C53,14.3553114 53.3553114,14 53.7930403,14 L57.2069597,14 C57.6446886,14 58,14.3553114 58,14.7930403 L58,18.2069597 C58,18.6446886 57.6446886,19 57.2069597,19",
    id: "Fill-36",
    fill: "#5D76A0",
    mask: "url(#mask-rbulmv-ei0-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2069597,26 L34.7930403,26 C34.3553114,26 34,25.6446886 34,25.2069597 L34,21.7930403 C34,21.3553114 34.3553114,21 34.7930403,21 L38.2069597,21 C38.6446886,21 39,21.3553114 39,21.7930403 L39,25.2069597 C39,25.6446886 38.6446886,26 38.2069597,26",
    id: "Fill-37",
    fill: "#3AA1C7",
    mask: "url(#mask-rbulmv-ei0-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2069597,26 L40.7930403,26 C40.3553114,26 40,25.6446886 40,25.2069597 L40,21.7930403 C40,21.3553114 40.3553114,21 40.7930403,21 L44.2069597,21 C44.6446886,21 45,21.3553114 45,21.7930403 L45,25.2069597 C45,25.6446886 44.6446886,26 44.2069597,26",
    id: "Fill-38",
    fill: "#FBD2B3",
    mask: "url(#mask-rbulmv-ei0-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2069597,26 L47.7930403,26 C47.3553114,26 47,25.6446886 47,25.2069597 L47,21.7930403 C47,21.3553114 47.3553114,21 47.7930403,21 L51.2069597,21 C51.6446886,21 52,21.3553114 52,21.7930403 L52,25.2069597 C52,25.6446886 51.6446886,26 51.2069597,26",
    id: "Fill-39",
    fill: "#7E5B59",
    mask: "url(#mask-rbulmv-ei0-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2069597,26 L53.7930403,26 C53.3553114,26 53,25.6446886 53,25.2069597 L53,21.7930403 C53,21.3553114 53.3553114,21 53.7930403,21 L57.2069597,21 C57.6446886,21 58,21.3553114 58,21.7930403 L58,25.2069597 C58,25.6446886 57.6446886,26 57.2069597,26",
    id: "Fill-40",
    fill: "#B25F46",
    mask: "url(#mask-rbulmv-ei0-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2069597,33 L34.7930403,33 C34.3553114,33 34,32.6446886 34,32.2069597 L34,28.7930403 C34,28.3553114 34.3553114,28 34.7930403,28 L38.2069597,28 C38.6446886,28 39,28.3553114 39,28.7930403 L39,32.2069597 C39,32.6446886 38.6446886,33 38.2069597,33",
    id: "Fill-41",
    fill: "#DDCF21",
    mask: "url(#mask-rbulmv-ei0-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2069597,33 L40.7930403,33 C40.3553114,33 40,32.6446886 40,32.2069597 L40,28.7930403 C40,28.3553114 40.3553114,28 40.7930403,28 L44.2069597,28 C44.6446886,28 45,28.3553114 45,28.7930403 L45,32.2069597 C45,32.6446886 44.6446886,33 44.2069597,33",
    id: "Fill-42",
    fill: "#A43157",
    mask: "url(#mask-rbulmv-ei0-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2069597,33 L47.7930403,33 C47.3553114,33 47,32.6446886 47,32.2069597 L47,28.7930403 C47,28.3553114 47.3553114,28 47.7930403,28 L51.2069597,28 C51.6446886,28 52,28.3553114 52,28.7930403 L52,32.2069597 C52,32.6446886 51.6446886,33 51.2069597,33",
    id: "Fill-43",
    fill: "#EA246E",
    mask: "url(#mask-rbulmv-ei0-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2069597,33 L53.7930403,33 C53.3553114,33 53,32.6446886 53,32.2069597 L53,28.7930403 C53,28.3553114 53.3553114,28 53.7930403,28 L57.2069597,28 C57.6446886,28 58,28.3553114 58,28.7930403 L58,32.2069597 C58,32.6446886 57.6446886,33 57.2069597,33",
    id: "Fill-44",
    fill: "#78A7B2",
    mask: "url(#mask-rbulmv-ei0-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2069597,39 L34.7930403,39 C34.3553114,39 34,38.6446886 34,38.2069597 L34,34.7930403 C34,34.3553114 34.3553114,34 34.7930403,34 L38.2069597,34 C38.6446886,34 39,34.3553114 39,34.7930403 L39,38.2069597 C39,38.6446886 38.6446886,39 38.2069597,39",
    id: "Fill-45",
    fill: "#624D7D",
    mask: "url(#mask-rbulmv-ei0-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2069597,39 L40.7930403,39 C40.3553114,39 40,38.6446886 40,38.2069597 L40,34.7930403 C40,34.3553114 40.3553114,34 40.7930403,34 L44.2069597,34 C44.6446886,34 45,34.3553114 45,34.7930403 L45,38.2069597 C45,38.6446886 44.6446886,39 44.2069597,39",
    id: "Fill-46",
    fill: "#3E7778",
    mask: "url(#mask-rbulmv-ei0-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2069597,39 L47.7930403,39 C47.3553114,39 47,38.6446886 47,38.2069597 L47,34.7930403 C47,34.3553114 47.3553114,34 47.7930403,34 L51.2069597,34 C51.6446886,34 52,34.3553114 52,34.7930403 L52,38.2069597 C52,38.6446886 51.6446886,39 51.2069597,39",
    id: "Fill-47",
    fill: "#FABB70",
    mask: "url(#mask-rbulmv-ei0-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2069597,39 L53.7930403,39 C53.3553114,39 53,38.6446886 53,38.2069597 L53,34.7930403 C53,34.3553114 53.3553114,34 53.7930403,34 L57.2069597,34 C57.6446886,34 58,34.3553114 58,34.7930403 L58,38.2069597 C58,38.6446886 57.6446886,39 57.2069597,39",
    id: "Fill-48",
    fill: "#EE6D89",
    mask: "url(#mask-rbulmv-ei0-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2069597,46 L34.7930403,46 C34.3553114,46 34,45.6446886 34,45.2069597 L34,41.7930403 C34,41.3553114 34.3553114,41 34.7930403,41 L38.2069597,41 C38.6446886,41 39,41.3553114 39,41.7930403 L39,45.2069597 C39,45.6446886 38.6446886,46 38.2069597,46",
    id: "Fill-49",
    fill: "#F9AC1E",
    mask: "url(#mask-rbulmv-ei0-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2069597,46 L40.7930403,46 C40.3553114,46 40,45.6446886 40,45.2069597 L40,41.7930403 C40,41.3553114 40.3553114,41 40.7930403,41 L44.2069597,41 C44.6446886,41 45,41.3553114 45,41.7930403 L45,45.2069597 C45,45.6446886 44.6446886,46 44.2069597,46",
    id: "Fill-50",
    fill: "#F7BABA",
    mask: "url(#mask-rbulmv-ei0-2)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfrastructure);
export default __webpack_public_path__ + "static/media/infrastructure.6b090982dc5e7399936bed83de492826.svg";
export { ForwardRef as ReactComponent };